export default __webpack_public_path__ + "static/css/xblock-styles.6064348f2df839b1f5bc0de81cc58ccd.css";